<template>
  <transition name="el-zoom-in-center">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Default box -->
        <div class="box">
          <div class="box-header">
            <div class="box-header with-border">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>用户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/user/userList' }">用户列表</el-breadcrumb-item>
                <el-breadcrumb-item>权限编辑</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="box-body" >

            <div v-for="(levelOne,index) in checkData.item">
              <el-checkbox v-model="checkAll[index]" :label="levelOne.code" :key="index"
                           @change="handleCheckAllChange(levelOne.item, index)">
                <span style="font-size: 22px; color: #f4c950">{{levelOne.title}}</span>
              </el-checkbox>
              <!--&lt;!&ndash; 详细样式参考 http://element-cn.eleme.io/#/zh-CN/component/form &ndash;&gt;-->
              <el-checkbox-group v-model="checkList">
                <el-checkbox v-for="levelTwo in levelOne.item" :label="levelTwo.code" :key="levelTwo.code"
                             @change="handleCheckedAuthChange(levelOne.item,index)">
                  {{levelTwo.title}}
                </el-checkbox>
              </el-checkbox-group>
              <div style="margin: 15px 0;"></div>
            </div>
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <el-button @click="onCancel">返回</el-button>
            <!-- /.box-body -->
          </div>
        </div>
        <!-- /.box -->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'AuthModify',
    data: function () {
      return {
        checkData: {},
        checkList: [],
        checkAll: [],
        userId: '',
        userType: ''
      }
    },
    mounted: function () {
      this.userId = this.$route.query.id;
      this.userType = this.$route.query.userType;
      this.getMenuData();
    },
    methods: {
      getMenuData: function () {
        let menuData = null;
        // console.log(this.userType);
        if (this.userType === 'ORDINARY') {
          menuData = require('../../../menu.json')
        } else {
          menuData = require('../../../menu_school.json')
        }
        this.checkData = menuData
        this.axios.post('/admin/user/roleList', [],
          {
            params: {userId: this.userId}
          })
          .then(resp => {
            this.checkList = resp.data.data
           // console.log(menuData.item)
            for (var x in menuData.item) {
              var checkNum = 0;
              for (var i in menuData.item[x].item) {
                if (this.checkList.indexOf(menuData.item[x].item[i].code) !== -1) {
                  checkNum++
                }
              }
              if (checkNum === menuData.item[x].item.length) {
                this.checkAll[x] = true
              } else {
                this.checkAll[x] = false
              }
            }
          }).catch(resp => {
        })
      },
      handleCheckAllChange: function (value, index) {
        var existArr = []
        for (var x in value) {
          if (this.checkList.indexOf(value[x].code) === -1) {
            this.checkList.push(value[x].code)
          } else {
            existArr.push(value[x].code)
          }
          this.checkAll[index] = true
        }
        if (existArr.length === value.length) {
          for (var i in existArr) {
            this.checkList.splice(this.checkList.indexOf(existArr[i]), 1);
          }
          this.checkAll[index] = false
        }
      },
      handleCheckedAuthChange: function (value, index) {
        var checkNum = 0
        for (var x in value) {
          if (this.checkList.indexOf(value[x].code) !== -1) {
            checkNum++
          }
        }
        if (checkNum === value.length) {
          this.checkAll[index] = true
        } else {
          this.checkAll[index] = false
        }
      },
      onSubmit: function () { //  TODO 录入检查方案
        this.axios.post('/admin/user/updateRole', this.checkList,
          {
            params: {userId: this.userId}
          })
          .then(resp => { // 保存成功跳回列表页面
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$router.replace('/user/userList')
          }).catch(resp => {
          this.$message({
            type: 'error',
            message: '请求服务器出错'
          })
        })
      },
      onCancel: function () {
        this.$router.replace('/user/userList')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AuthModify.vue?3bedf9d9